import React, { memo } from 'react';
import classNames from 'classnames';

import { unwrap as unwrapChangeSpy } from 'src/utils/ChangeSpy';

import { ContactContextMenuWrapper } from '../ContactContextMenuWrapper';

import style from './style.module.css';

const blockStyle = { display: 'block' };

const unwrap = value => {
  value = unwrapChangeSpy(value);
  if (value && value.get) value = value.get('name', '');

  return value;
};

const ContactLabelComponent = ({ childProps: { contact, isOpen, onDelete, onClick, entityId }, ...rest }) => {
  const calculatedClassName = classNames({
    active: isOpen,
    'text-italic text-muted': unwrap(contact?.getIn(['pivot', 'endYear'], '')),
  });

  const firstName = unwrap(contact?.get('firstName', ''));
  const lastName = unwrap(contact?.get('lastName', ''));
  const title = unwrap(contact?.getIn(['pivot', 'title'], ' '));
  const shouldContext = unwrap(contact?.getIn(['pivot', 'entityId'], ' ')) === entityId;
  const entityName = unwrap(contact?.getIn(['entityName'], ' '));

  if (shouldContext) {
    return (
      <li className={classNames(style.host, style.sortable, calculatedClassName)} onClick={onClick} {...rest}>
        <a className={classNames(blockStyle, 'clickable')}>
          <ContactContextMenuWrapper data={contact} onDelete={onDelete}>
            {firstName} {lastName}
            <br />
            <small>{title}</small>
          </ContactContextMenuWrapper>
        </a>
      </li>
    );
  }

  return (
    <li className={classNames(style.host, calculatedClassName)} onClick={onClick} {...rest}>
      <a className="clickable" style={blockStyle}>
        <div>
          {firstName} {lastName}
          <br />
          <small>{title}</small> <br />
          <small>{entityName}</small>
        </div>
      </a>
    </li>
  );
};

/** Contact label component. */
export const ContactLabel = memo(ContactLabelComponent);
